import { theme } from '../Theme';
import { css } from 'emotion';

export const eztradStyling = css`
  .button-container a {
    border-color: ${theme.colors.mediumGrey};
  }
  .title-container h1 {
    color: ${theme.colors.almostBlack};
  }
  .row .info .info-item h2 {
    font-weight: 700;
    font-size: 0.875rem;

    text-transform: uppercase;
    font-variant: normal;
  }
`;
